import React from "react";
import { Link } from "react-router-dom";

import * as Styled from "./not-found.styles";

// The KMMRCE loading spinner was rendered above the title: another product's
// purple branding in a Felix dashboard, and a *loading* indicator on a screen
// whose whole message is that there is nothing to load.
export const NotFound = () => (
  <Styled.Wrapper>
    <Styled.Title>Page not found!</Styled.Title>
    <Styled.Text>
      Looks like the page you are looking for does not exist
    </Styled.Text>
    <Link className="btn btn-primary" to="/">
      Home
    </Link>
  </Styled.Wrapper>
);

export default NotFound;
